import { useCallback } from 'react'

import Flex from '@/elements/Flex'
import NotificationSettings from '@/components/NotificationSettings'
import { updateOrgIndividualNotificationSettings, useGetOrgIndividualNotificationsSettings } from '@/api/notifications'
import type { NotificationSettingResponse } from '@/api/types/Notification'
import toast from '@/utils/toast'

function IndividualNotificationsPreferences({ organizationIndividualId }: { organizationIndividualId: string }) {
  const { data: orgIndividualNotifications, isLoading, refetch } = useGetOrgIndividualNotificationsSettings(organizationIndividualId)

  const submitUpdateNotifications = useCallback(async (id: NotificationSettingResponse['id'], value: NotificationSettingResponse['value']) => {
    try {
      await updateOrgIndividualNotificationSettings(organizationIndividualId, id, value)
      toast.success('Notification updated')
    } catch {
      toast.error('Failed to update notification')
    }
    await refetch()
  }, [organizationIndividualId, refetch])

  return (
    <Flex fraction={6} wfull hfull align='stretch'>
      <NotificationSettings
        loading={isLoading}
        notifications={orgIndividualNotifications?.data || []}
        onSave={submitUpdateNotifications}
      />
    </Flex>
  )
}

export default IndividualNotificationsPreferences
